import { render, staticRenderFns } from "./AreaSearch.vue?vue&type=template&id=dbc25228&scoped=true"
import script from "./AreaSearch.vue?vue&type=script&lang=js"
export * from "./AreaSearch.vue?vue&type=script&lang=js"
import style0 from "./AreaSearch.vue?vue&type=style&index=0&id=dbc25228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc25228",
  null
  
)

export default component.exports